import React from "react";
import { Loader } from "@mantine/core";

import styles from "./page-loader.module.scss";

const PageLoader = () => (
  <div className={styles.loaderContainer}>
    <Loader className={styles.loader} size={32} />
  </div>
);

export default PageLoader;
